// src/components/admin/AdminNavbar.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { notifications } from '../../../components/admin/data/dummyData';
import '../../../assets/css/admin/AdminNavbar.css';

const AdminNavbar = ({ sidebarOpen, onLogout, toggleSidebar }) => {
  const navigate = useNavigate();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const unreadCount = notifications.filter(n => !n.read).length;

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      onLogout();
      navigate('/login');
    }
  };

  return (
    <nav className={`admin-navbar ${!sidebarOpen ? 'full-width' : ''}`}>
      {/* Left Section */}
      <div className="navbar-left">
        {/* Sidebar Toggle Button */}
        <button 
          className="navbar-toggle-btn" 
          onClick={toggleSidebar}
          aria-label="Toggle Sidebar"
        >
          <span className="toggle-icon">☰</span>
        </button>
        
        <h2 className="navbar-title">CircleHub Admin</h2>
      </div>

      {/* Right Section */}
      <div className="navbar-right">
        

        {/* Notifications */}
        <div style={{ position: 'relative' }}>
          <button 
            className={`navbar-icon-btn ${showNotifications ? 'active' : ''}`}
            onClick={() => {
              setShowNotifications(!showNotifications);
              setShowProfile(false);
            }}
          >
            🔔
            {unreadCount > 0 && (
              <span className="icon-badge">{unreadCount}</span>
            )}
          </button>

          {/* Notifications Dropdown */}
          <div className={`notifications-dropdown ${showNotifications ? 'active' : ''}`}>
            <div className="notifications-header">
              <h4>Notifications</h4>
              <span className="mark-read-btn">Mark all read</span>
            </div>
            <div className="notifications-list">
              {notifications.map((notification) => (
                <div 
                  key={notification.id} 
                  className={`notification-item ${!notification.read ? 'unread' : ''}`}
                >
                  <div className={`notification-icon ${notification.type}`}>
                    {notification.type === 'info' ? 'ℹ️' : 
                     notification.type === 'warning' ? '⚠️' : 
                     notification.type === 'success' ? '✅' : '📢'}
                  </div>
                  <div className="notification-content">
                    <div className="notification-title">{notification.title}</div>
                    <div className="notification-text">{notification.message}</div>
                    <div className="notification-time">{notification.time}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="notifications-footer">
              <span className="view-all-btn">View all notifications</span>
            </div>
          </div>
        </div>

        {/* Profile */}
        <div style={{ position: 'relative' }}>
          <div 
            className="profile-trigger"
            onClick={() => {
              setShowProfile(!showProfile);
              setShowNotifications(false);
            }}
          >
            <div className="profile-trigger-avatar">A</div>
            <div className="profile-trigger-info">
              <div className="profile-trigger-name">Admin User</div>
              <div className="profile-trigger-role">Administrator</div>
            </div>
            <span className="profile-trigger-icon">▼</span>
          </div>

          {/* Profile Dropdown */}
          <div className={`profile-dropdown ${showProfile ? 'active' : ''}`}>
            <div className="dropdown-header">
              <div className="dropdown-header-name">Admin User</div>
              <div className="dropdown-header-email">admin@circlehub.com</div>
            </div>
            <div className="dropdown-menu">
              <div className="dropdown-item" onClick={() => navigate('/admin/settings')}>
                <span className="dropdown-item-icon">👤</span>
                My Profile
              </div>
              <div className="dropdown-item" onClick={() => navigate('/admin/settings')}>
                <span className="dropdown-item-icon">⚙️</span>
                Settings
              </div>
              <div className="dropdown-item">
                <span className="dropdown-item-icon">❓</span>
                Help & Support
              </div>
              <div className="dropdown-divider"></div>
              <div className="dropdown-item danger" onClick={handleLogout}>
                <span className="dropdown-item-icon">🚪</span>
                Logout
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;